import type { MastraJob, MastraPatchBody, RunResult } from './types';

const BASE = '/scheduler-api/scheduler';

async function schedulerFetch<T>(
  path: string,
  init?: RequestInit,
): Promise<T> {
  const res = await fetch(path, {
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    ...init,
  });
  const data: unknown = res.headers.get('content-type')?.includes('application/json')
    ? await res.json()
    : await res.text();
  if (!res.ok) {
    let msg = `Request failed (${res.status})`;
    if (typeof data === 'object' && data !== null) {
      const d = data as Record<string, unknown>;
      if (typeof d.message === 'string') msg = d.message;
      else if (typeof d.error === 'string') msg = d.error;
    }
    const err = new Error(msg) as Error & { status: number };
    err.status = res.status;
    throw err;
  }
  return data as T;
}

export async function listMastraJobs(): Promise<MastraJob[]> {
  const res = await schedulerFetch<{ jobs: MastraJob[] }>(BASE);
  if (!Array.isArray(res?.jobs)) throw new Error('Unexpected scheduler response shape');
  return res.jobs;
}

export async function patchMastraJob(
  id: string,
  body: MastraPatchBody,
): Promise<MastraJob> {
  return schedulerFetch<MastraJob>(`${BASE}/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export async function runMastraJob(id: string): Promise<RunResult> {
  return schedulerFetch<RunResult>(`${BASE}/${id}/run`, {
    method: 'POST',
  });
}
